import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import back from '~/assets/images/arrow.svg';
import { useHistory, Redirect } from 'react-router-dom';
import Loading from '~/components/layout/Loading';
import OpenChatBot from '~/components/layout/Chatbot';
import {
  Container,
  HeaderIcon,
  HeaderText,
  CloseIcon,
  CloseIconContainer,
  PageTitleContainer,
  PageIcon,
  PageTitle,
  BankSlipsContainer,
  Content,
  NextPage,
  NextPageContainer,
  HeaderContainer,
  WrapperInvoices,
  HeaderMobile,
  DesktopWrapper,
  MobileWrapper,
  InvoiceMessage,
} from './styles';
import Item from '~/components/pages/Invoices/Item';
import ItemMobile from '~/components/pages/Invoices/ItemMobile';
import api from '~/services/api';
import ModalInvoice from '~/components/pages/Invoices/Modal';
import ModalMobileInvoice from '~/components/pages/Invoices/ModalMobile';
import { analytics, logEvent }  from "~/services/firebaseConfig";
import SideBar from '~/components/layout/Sidebar';
import Header from '~/components/layout/Header';
import '~/components/styles/Global.css';
import { useDispatch, useSelector } from 'react-redux';
import { verifyRoles } from '~/utils/functions/verifyRoles';

export default function Invoices(props) {
  const economicGroupReducer = useSelector(state => state.economicGroupReducer);
  const invoiceReducer = useSelector((state) => state.invoiceReducer);

  const history = useHistory();
  const dispatch = useDispatch();

  const [invoices, setInvoices] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalMobile, setOpenModalMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingNext, setLoadingNext] = useState(false);
  const [offset, setOffset] = useState(0);
  const [notNext, setNotNext] = useState(false);
  const roles = useSelector(state => state.rolesReducer.roles);

  useEffect(() => {
    if (!localStorage.getItem('codeStore')) {
      window.location.href = '/acessar?error';
    } else {
      localStorage.removeItem('storeInfo');
    }
  }, []);

  useEffect(() => {
    setOffset(0);
    setNotNext(false);
    const storeInfoCode = localStorage.getItem('codeStore').split('-');
    const storeInfo = localStorage.getItem('storeInfo');
    if (!storeInfo) {
      localStorage.setItem('storeInfo', storeInfoCode[0]);
      setLoading(true);
      requestInvoices(storeInfoCode, true, 0, true);
    } else {
        localStorage.setItem('storeInfo', storeInfoCode[0]);
        setLoading(true);
        requestInvoices(storeInfoCode, true, 0, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [economicGroupReducer.selectedStore]);

  const requestInvoices = async (
    storeInfo,
    offsetOption,
    offsetValue,
    changeEG,
  ) => {
    const customerCode = storeInfo[0];
    const customerSiteCode = storeInfo[1];
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let invoiceNumber = await params.get('invoice-number');

    let url = `industrial/invoice/v1/invoices?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&_expand=installments&_limit=20&_order_by=emissionDate DESC&_offset=${
      offsetOption ? offsetValue : offsetValue - 1
    }`;

    if (invoiceNumber) {
      url = `industrial/invoice/v1/invoices?customer-site-code=${customerSiteCode}&customer-code=${customerCode}&invoice-number=${invoiceNumber}&_expand=installments&_limit=1&_order_by=emissionDate DESC&_offset=${
        offsetOption ? offsetValue : offsetValue - 1
      }`;
    }

    api
      .get(url, parameters)
      .then(res => {
        setLoadingNext(false);

        if (res.status === 200) {
          const response = res.data;
          let invoicesArray = invoices;
          if (!changeEG) {
            response.map(invoice => {
              invoicesArray.push(invoice);
            });
          } else {
            invoicesArray = res.data;
          }
          if (invoiceNumber && invoicesArray.length === 1) {
            if (window.screen.width > 770) {
              handleOpenModal(invoicesArray[0]);
            } else {
              handleOpenMobileModal(invoicesArray[0]);
            }
          }
          if (response.length < 20) {
            setNotNext(true);
          }
          dispatch({ type: "SET_INVOICES", invoices: invoicesArray });
          setInvoices(invoicesArray);
          setLoading(false);
        }
      })
      .catch(err => {
        setLoadingNext(false);
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        }
      });
  };

  function handleOpenModal(invoices) {
    dispatch({
      type: 'invoice/GET_MODAL_INFORMATION',
      modalInformation: invoices,
    });
    setOpenModal(!openModal);
  }

  function handleOpenMobileModal(invoices) {
    dispatch({
      type: 'invoice/GET_MODAL_INFORMATION',
      modalInformation: invoices,
    });
    setOpenModalMobile(!openModalMobile);
  }

  const nextPage = () => {
    logEvent(analytics, 'carregar_mais_notas');
    const storeInfo = localStorage.getItem('codeStore').split('-');
    requestInvoices(storeInfo, true, offset + 1, false);
    setOffset(offset + 1);
    setLoadingNext(true);
  };

  return (
    <>
      {verifyRoles(roles, 'NOTAS_FISCAIS') ? (
        <>
          {openModal ? (
            <ModalInvoice close={() => handleOpenModal()} />
          ) : openModalMobile ? (
            <ModalMobileInvoice close={() => handleOpenMobileModal()} />
          ) : (
            <SideBar menuSelected={'Minha Conta'} disabledOnMobile>
              <Container>
                <HeaderContainer>
                  <Header
                    disabledOnMobile
                  />
                </HeaderContainer>
                <Content>
                  <HeaderMobile>
                    <HeaderIcon className="mdi mdi-store mr-2" />
                    <HeaderText>{localStorage.getItem('storeName')}</HeaderText>
                  </HeaderMobile>
                  <WrapperInvoices>
                    <CloseIconContainer>
                      <CloseIcon>
                        <img
                          src={back}
                          alt="Ícone para voltar"
                          onClick={() => {
                            history.push('/minha-conta');
                          }}
                        />
                      </CloseIcon>
                    </CloseIconContainer>
                    <PageTitleContainer>
                      <PageIcon className="mdi mdi-receipt mr-2" />
                      <PageTitle>Notas</PageTitle>
                    </PageTitleContainer>
                    {loading ? (
                      <Loading />
                    ) : (
                      <>
                        {invoiceReducer.invoices.length < 1 ? (
                          <InvoiceMessage>
                            <span>Nenhuma nota encontrada</span>
                          </InvoiceMessage>
                        ) : (
                          <BankSlipsContainer>
                            <DesktopWrapper>
                              {invoiceReducer.invoices.map((invoice, index) => (
                                <Item
                                  data={invoice}
                                  key={index}
                                  openModal={() => handleOpenModal(invoice)}
                                />
                              ))}
                            </DesktopWrapper>
                            <MobileWrapper>
                              {invoiceReducer.invoices.map((invoice, index) => (
                                <ItemMobile
                                  data={invoice}
                                  key={index}
                                  openModal={() =>
                                    handleOpenMobileModal(invoice)
                                  }
                                />
                              ))}
                            </MobileWrapper>
                            <NextPageContainer content="center">
                              {notNext ? null : (
                                <NextPage onClick={() => nextPage()}>
                                  {loadingNext ? (
                                    <i
                                      className="fa fa-spinner fa-pulse fa-3x fa-fw"
                                      style={{
                                        fontSize: '16px',
                                        color: '#000FFF',
                                      }}
                                    />
                                  ) : (
                                    'Carregar mais...'
                                  )}
                                </NextPage>
                              )}
                            </NextPageContainer>
                          </BankSlipsContainer>
                        )}
                      </>
                    )}
                  </WrapperInvoices>
                </Content>
              </Container>
              <OpenChatBot />
            </SideBar>
          )}
        </>
      ) : (
        <Redirect to="/portal" />
      )}
    </>
  );
}
